type RouterSubscribeState = { location: { pathname: string } };
type SubscribableRouter = {
  subscribe: (cb: (state: RouterSubscribeState) => void) => () => void;
};

let previousPath = '';
let currentPath = window.location.pathname;

// Holds the active unsubscribe handle so repeated calls (e.g. HMR) tear down the previous subscription before registering a new one.
let _unsubscribe: (() => void) | null = null;

export function initNavigationTracker(router: SubscribableRouter): () => void {
  _unsubscribe?.(); // Remove any stale subscription from a previous call
  _unsubscribe = router.subscribe((state) => {
    previousPath = currentPath;
    currentPath = state.location.pathname;
  });
  return _unsubscribe;
}

export function getPreviousNavigationPath(): string {
  return previousPath;
}

// TODO(signoz-cleanup): Remove — exported but never referenced anywhere in the codebase
// export function getCurrentNavigationPath(): string {
//   return currentPath;
// }
